import { Globe } from 'lucide-react';
import { useTranslation } from '@/i18n/TranslationContext';
import { cn } from '@/lib/utils';

export function LanguageToggle({ className }) {
  const { language, setLanguage } = useTranslation();

  return (
    <div className={cn("flex items-center gap-0.5 rounded-lg border border-border/60 px-1.5 py-1", className)} data-testid="language-toggle">
      <Globe className="h-3.5 w-3.5 text-muted-foreground mr-1" />
      <button
        onClick={() => setLanguage('en')}
        className={cn(
          'px-1.5 py-0.5 rounded text-xs font-semibold transition-colors duration-200',
          language === 'en' ? 'text-primary bg-primary/10' : 'text-muted-foreground hover:text-foreground'
        )}
        data-testid="lang-en"
      >
        EN
      </button>
      <span className="text-muted-foreground/40 text-xs">|</span>
      <button
        onClick={() => setLanguage('es')}
        className={cn(
          'px-1.5 py-0.5 rounded text-xs font-semibold transition-colors duration-200',
          language === 'es' ? 'text-primary bg-primary/10' : 'text-muted-foreground hover:text-foreground'
        )}
        data-testid="lang-es"
      >
        ES
      </button>
    </div>
  );
}
